import { Chakra } from "@airhelp/react-ui-components";
import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { ArrowRightIcon } from "styles/icons";
import { StickyBottomBarAhPlusLogo } from "./StickyBottomBarAhPlusLogo";
import { stickyBottomBarMobileStyles } from "./StickyBottomBarMobile.styles";
import { useDynamicIndex } from "./StickyBottomBarMobile.hook";
import type { StickyBottomBarIconProps, StickyBottomBarProps } from "../StickyBottomBar.d";
import { getCTAElementProps } from "../utils/getCTAElementProps";

const { Fade, Flex, Text, Button, Box } = Chakra;

const StickyBottomBarMobile = ({
  iconsWithText,
  variant,
  heading,
}: {
  iconsWithText: StickyBottomBarIconProps[];
  variant: StickyBottomBarProps["variant"];
  heading: StickyBottomBarProps["heading"];
}) => {
  const language = useLanguage();
  const index = useDynamicIndex(iconsWithText.length);
  const translations = useTranslations();
  const Icon = iconsWithText[index].icon;
  const CTAElementProps = getCTAElementProps(language, variant);

  const actionButton = {
    basic: (
      <Box sx={stickyBottomBarMobileStyles[variant].actionButton} pointerEvents="none">
        <Fade in key={iconsWithText[index].textKey}>
          <Text color="greyscale.100" fontSize="sm" fontWeight="bold">
            {translations(iconsWithText[index].textKey)} <ArrowRightIcon ml="6px" />
          </Text>
        </Fade>
      </Box>
    ),
    ahPlus: (
      <Button size="xs" sx={stickyBottomBarMobileStyles[variant].actionButton} pointerEvents="none">
        <ArrowRightIcon />
      </Button>
    ),
  }[variant];

  const customHeading = {
    basic: translations("check_compensation"),
    ahPlus: heading || translations("be_prepared_for_future_flight_disruptions"),
  }[variant];

  return (
    <Flex
      align="flex-start"
      px={4}
      py={5}
      borderRadius="lg"
      mx={4}
      mb={4}
      as="a"
      sx={stickyBottomBarMobileStyles[variant].container}
      {...CTAElementProps}
    >
      <Flex sx={stickyBottomBarMobileStyles[variant].iconsWithText}>
        <Fade in key={iconsWithText[index].textKey}>
          <Flex borderRadius="50%" border="2px solid" borderColor="primary.400" mr={3} p={2}>
            <Icon boxSize={5} />
          </Flex>
        </Fade>
      </Flex>
      <Flex sx={stickyBottomBarMobileStyles[variant].innerContainer}>
        <StickyBottomBarAhPlusLogo mr={3} sx={stickyBottomBarMobileStyles[variant].logo} />
        <Text as="span" fontWeight={700} sx={stickyBottomBarMobileStyles[variant].heading}>
          {customHeading}
        </Text>
        {actionButton}
      </Flex>
    </Flex>
  );
};

export default StickyBottomBarMobile;
